import type {
  PacketDetail,
  PathLookupPathInspectorSelectedPacket,
} from 'components/DeviceView/deviceViewTypes';
import type { GraphData } from 'components/Graph/model/GraphData';
import type { Draft } from 'immer';
import { getTrafficScore } from './getTrafficScore';

export const addTrafficScoreToPacketDetail = (
  nodeSelectedPackets: Draft<PathLookupPathInspectorSelectedPacket>,
  graphData: GraphData,
  detail: PacketDetail | null,
): void => {
  const trafficScore = detail && getTrafficScore(graphData, detail.id);
  nodeSelectedPackets.selectedIncomingPacket = trafficScore
    ? Object.assign(detail, { trafficScore })
    : detail;
};
